import { SITE } from "@/config/site";

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-2.5">
    <span
      className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${
        light ? "bg-white" : "bg-navy-800"
      }`}
      aria-hidden="true"
    >
      <svg viewBox="0 0 24 24" className={`h-5 w-5 ${light ? "text-navy-800" : "text-white"}`} fill="currentColor">
        <path d="M9 3h6v6h6v6h-6v6H9v-6H3V9h6V3z" />
      </svg>
    </span>
    <span className="leading-tight">
      <span className={`block font-heading text-base font-bold tracking-tight sm:text-lg ${light ? "text-white" : "text-navy-900"}`}>
        {SITE.name}
      </span>
      <span className={`block text-[11px] font-medium ${light ? "text-slate-300" : "text-slate-500"}`}>
        {SITE.location}
      </span>
    </span>
  </span>
);
